// based on rc-calendar 9.10.10
import Vue from 'vue';
import ref from 'vue-ref';
import Calendar from './src/';

Vue.use(ref, { name: 'ant-ref' });

export default Calendar;
